import styled from 'styled-components';

export const StyledAcceptInvite = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e2f6fe;
  padding: 20px;
  position: relative;
  overflow: hidden;

  /* Decorative elements matching your theme */
  &::before {
    content: '';
    position: absolute;
    top: -100px;
    right: -100px;
    width: 400px;
    height: 400px;
    background: radial-gradient(circle, rgba(102, 126, 234, 0.1) 0%, transparent 70%);
    border-radius: 50%;
    pointer-events: none;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -150px;
    left: -150px;
    width: 500px;
    height: 500px;
    background: radial-gradient(circle, rgba(118, 75, 162, 0.08) 0%, transparent 70%);
    border-radius: 50%;
    pointer-events: none;
  }

  .container {
    width: 100%;
    max-width: 520px;
    position: relative;
    z-index: 1;
  }

  .card {
    background: white;
    border-radius: 20px;
    padding: 45px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(10px);

    @media (max-width: 576px) {
      padding: 35px 25px;
      border-radius: 16px;
    }
  }

  .error-card {
    text-align: center;

    h2 {
      color: #ff4d4f;
      margin-bottom: 16px;
      font-size: 26px;
      font-weight: 600;
    }

    p {
      color: #595959;
      margin-bottom: 28px;
      font-size: 15px;
      line-height: 1.6;
    }
  }

  .header {
    text-align: center;
    margin-bottom: 36px;
    padding-bottom: 24px;
    border-bottom: 2px solid #f0f5ff;

    h1 {
      font-size: 30px;
      font-weight: 700;
      color: #1a1a1a;
      margin-bottom: 14px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;

      @media (max-width: 576px) {
        font-size: 26px;
      }
    }

    .subtitle {
      color: #595959;
      font-size: 15px;
      line-height: 1.7;
      margin: 0;
      font-weight: 400;

      strong {
        color: #667eea;
        font-weight: 600;
        position: relative;

        &::after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 0;
          right: 0;
          height: 2px;
          background: linear-gradient(90deg, #667eea 0%, transparent 100%);
          opacity: 0.3;
        }
      }
    }
  }

  .invite-details {
    background: linear-gradient(135deg, #f8f9ff 0%, #f0f5ff 100%);
    border-radius: 14px;
    padding: 24px;
    margin-bottom: 28px;
    border: 1px solid #e6edff;
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 4px;
      height: 100%;
      background: linear-gradient(180deg, #667eea 0%, #764ba2 100%);
    }

    .detail-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 0;

      &:not(:last-child) {
        border-bottom: 1px solid rgba(102, 126, 234, 0.1);
      }

      .label {
        font-size: 14px;
        color: #8c8c8c;
        font-weight: 500;
        display: flex;
        align-items: center;
        gap: 8px;

        &::before {
          content: '•';
          color: #667eea;
          font-size: 20px;
        }
      }

      .value {
        font-size: 14px;
        color: #262626;
        font-weight: 600;
        text-align: right;
        max-width: 60%;
        word-break: break-word;

        &.role {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          padding: 6px 16px;
          border-radius: 8px;
          font-size: 13px;
          text-transform: uppercase;
          letter-spacing: 0.8px;
          box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25);
          font-weight: 600;
        }
      }
    }
  }

  .password-section {
    margin-bottom: 28px;

    .password-info {
      font-size: 15px;
      color: #595959;
      margin-bottom: 20px;
      text-align: center;
      font-weight: 500;
    }

    .password-requirements {
      font-size: 12px;
      color: #8c8c8c;
      margin-bottom: 20px;
      text-align: center;
      padding: 14px;
      background: linear-gradient(135deg, #f0f5ff 0%, #e6edff 100%);
      border-radius: 10px;
      border-left: 4px solid #667eea;
      line-height: 1.7;
    }
  }

  .button-group {
    display: flex;
    flex-direction: column;
    gap: 14px;
    margin-top: 28px;

    button {
      transition: all 0.3s ease;
      font-weight: 600;
      letter-spacing: 0.3px;

      &:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3);
      }

      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }

      &[variant='primary'] {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border: none;
        box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);

        &:hover:not(:disabled) {
          box-shadow: 0 8px 25px rgba(102, 126, 234, 0.5);
        }
      }

      &[variant='light'] {
        background: transparent;
        border: 2px solid #e8e8e8;
        color: #595959;

        &:hover:not(:disabled) {
          border-color: #667eea;
          color: #667eea;
          background: rgba(102, 126, 234, 0.05);
        }
      }
    }
  }

  /* Field overrides for better styling */
  .field-wrapper {
    margin-bottom: 18px;

    label {
      font-weight: 600;
      color: #262626;
      margin-bottom: 10px;
      font-size: 14px;
    }

    input {
      border: 2px solid #e8e8e8;
      border-radius: 10px;
      padding: 14px 18px;
      font-size: 14px;
      transition: all 0.3s ease;
      background: white;

      &:focus {
        border-color: #667eea;
        box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);
        background: #fafbff;
      }

      &::placeholder {
        color: #bfbfbf;
      }
    }

    .error-message {
      color: #ff4d4f;
      font-size: 12px;
      margin-top: 8px;
      display: flex;
      align-items: center;
      gap: 6px;

      &::before {
        content: '⚠';
        font-size: 14px;
      }
    }
  }

  /* Floating animation for decorative elements */
  @keyframes float {
    0%,
    100% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-20px);
    }
  }
`;
